export function noShrink(arb) {
    return arb.noShrink();
}
